class CollectionDescriptionReadMore extends HTMLElement {
  constructor() {
    super();
    this.init();
  }

  init() {
    const toggleButton = this.querySelector('[data-read-more-toggle]');
    const descriptionText = this.querySelector('[data-description-text]');
    const readMoreText = this.querySelector('.read-more-text');
    const readLessText = this.querySelector('.read-less-text');
    
    if (!toggleButton || !descriptionText) return;

    // Set initial state
    const maxHeight = 150; // Maximum height in pixels before showing "read more"
    const descriptionHeight = descriptionText.scrollHeight;
    
    // Only show read more if content exceeds max height
    if (descriptionHeight > maxHeight) {
      this.classList.add('has-read-more');
      descriptionText.classList.add('has-read-more');
      descriptionText.style.maxHeight = `${maxHeight}px`;
      descriptionText.style.overflow = 'hidden';
      descriptionText.style.transition = 'max-height 0.3s ease-out';
      toggleButton.style.display = 'inline-block';
      this.setAttribute('aria-expanded', 'false');
    } else {
      toggleButton.style.display = 'none';
    }

    toggleButton.addEventListener('click', () => {
      const isExpanded = this.getAttribute('aria-expanded') === 'true';
      
      if (isExpanded) {
        // Collapse
        descriptionText.style.maxHeight = `${maxHeight}px`;
        this.setAttribute('aria-expanded', 'false');
        toggleButton.setAttribute('aria-expanded', 'false');
        readMoreText.classList.remove('hidden');
        readLessText.classList.add('hidden');
      } else {
        // Expand - recalculate height to ensure accuracy
        const currentHeight = descriptionText.scrollHeight;
        descriptionText.style.maxHeight = `${currentHeight}px`;
        this.setAttribute('aria-expanded', 'true');
        toggleButton.setAttribute('aria-expanded', 'true');
        readMoreText.classList.add('hidden');
        readLessText.classList.remove('hidden');
      }
    });
  }
}

customElements.define('collection-description-read-more', CollectionDescriptionReadMore);

// Initialize for existing elements
document.addEventListener('DOMContentLoaded', () => {
  const containers = document.querySelectorAll('[data-read-more]');
  containers.forEach(container => {
    if (!container.closest('collection-description-read-more')) {
      const wrapper = document.createElement('collection-description-read-more');
      container.parentNode.insertBefore(wrapper, container);
      wrapper.appendChild(container);
    }
  });
});

